module.exports = "/assets/data/6958b54ce0873864c8d78e389b9b501d-CH45.data.json";